import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faUser from '@fortawesome/fontawesome-free-solid/faUser';
import faCheck from '@fortawesome/fontawesome-free-solid/faCheck';
import faExclamationTriangle from '@fortawesome/fontawesome-free-solid/faExclamationTriangle';

class RegisterName extends Component {

  onChange = (e) => {
    this.props.handleChange(e.target.value, 'name');    
  };

  render() {
    const { name, valid } = this.props;

    return (
      <div className="field is-horizontal">
        <div className="field-label is-medium">
          <label className="label">購買人姓名</label>
        </div>
        <div className="field-body">
          <div className="field">
            <p className="control is-expanded has-icons-left has-icons-right">
              <input
                className={!valid ? 'input' : 'input is-success'}
                type="text"
                id="register-name-input"
                placeholder="姓名"
                value={name}
                required
                onChange={this.onChange}
              />
              <span className="icon is-small is-left">
                <FontAwesomeIcon className="icon" icon={faUser} />
              </span>
              <span className="icon is-small is-right">
                <FontAwesomeIcon
                  className="icon"
                  icon={valid ? faCheck : faExclamationTriangle}
                />
              </span>
            </p>
            <p className="help is-danger">必填</p>
          </div>
        </div>
      </div>
    );
  }
}

RegisterName.propTypes = {
  handleChange: PropTypes.func.isRequired,
};

export default RegisterName;



// WEBPACK FOOTER //
// ./src/components/RegisterName.js